import { PublicPage, LegalSection } from "../components/PublicPage";
import { Mail, LifeBuoy, AlertTriangle } from "lucide-react";

const FAQ_ITEMS = [
  { q: "Cehnura est-il gratuit ?", a: "Oui, une offre gratuite complète est disponible. Des abonnements Premium (19,90 €/mois) et Pro (49,90 €/mois) débloquent des fonctionnalités avancées." },
  { q: "Comment fonctionne la marketplace ?", a: "Vous publiez une demande ou parcourez les professionnels. Un devis est émis, le paiement est sécurisé (séquestre), puis reversé au professionnel après validation de la livraison." },
  { q: "Mes paiements sont-ils sécurisés ?", a: "Oui. Tous les paiements sont traités par Stripe. Cehnura ne stocke aucune donnée de carte bancaire." },
  { q: "Comment gérer ou résilier mon abonnement ?", a: "Depuis votre espace Abonnement, vous pouvez mettre à niveau, changer d'offre ou résilier à tout moment. L'accès reste actif jusqu'à la fin de la période payée." },
  { q: "Qu'est-ce que l'espace Manager ?", a: "Un manager peut accompagner plusieurs créateurs (avec leur accord), suivre leur activité et émettre des devis en leur nom. L'artiste reste le bénéficiaire financier." },
  { q: "Comment supprimer mon compte ?", a: "Rendez-vous dans votre profil pour demander la suppression. Vos données associées seront effacées." },
];

function Faq() {
  return (
    <PublicPage title="Foire aux questions" testid="support-faq">
      <div className="space-y-4">
        {FAQ_ITEMS.map((item, i) => (
          <div key={i} className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5" data-testid={`faq-item-${i}`}>
            <h3 className="font-semibold text-zinc-100 mb-1">{item.q}</h3>
            <p className="text-zinc-400">{item.a}</p>
          </div>
        ))}
      </div>
    </PublicPage>
  );
}

function Help() {
  return (
    <PublicPage title="Centre d'aide" subtitle="Prise en main de Cehnura" testid="support-help">
      <LegalSection heading="Démarrer">
        <p>Créez votre compte, choisissez votre profil (Créateur, Professionnel ou Manager) lors de l'onboarding, puis suivez les recommandations de votre tableau de bord.</p>
      </LegalSection>
      <LegalSection heading="Créateur">
        <p>Transformez un objectif en projet et tâches, gagnez de l'XP, suivez votre progression et planifiez vos sorties.</p>
      </LegalSection>
      <LegalSection heading="Professionnel & Marketplace">
        <p>Complétez votre profil pro, définissez vos disponibilités, répondez aux demandes, émettez des devis et recevez vos paiements après livraison.</p>
      </LegalSection>
      <LegalSection heading="Besoin d'aide ?">
        <p>Consultez la <a href="/faq" className="text-amber-400 hover:underline">FAQ</a> ou contactez-nous à <a href="mailto:support@cehnura.com" className="text-amber-400 hover:underline">support@cehnura.com</a>.</p>
      </LegalSection>
    </PublicPage>
  );
}

function Contact() {
  return (
    <PublicPage title="Contact & Support" testid="support-contact">
      <div className="grid sm:grid-cols-2 gap-4">
        <a href="mailto:support@cehnura.com" data-testid="contact-email-card" className="bg-[#18181E] border border-zinc-800 rounded-2xl p-6 hover:border-amber-500/50 transition-colors block">
          <Mail className="w-6 h-6 text-amber-400 mb-3" />
          <h3 className="font-semibold text-zinc-100">Nous écrire</h3>
          <p className="text-zinc-400 text-sm mt-1">support@cehnura.com</p>
        </a>
        <a href="/aide" data-testid="contact-help-card" className="bg-[#18181E] border border-zinc-800 rounded-2xl p-6 hover:border-amber-500/50 transition-colors block">
          <LifeBuoy className="w-6 h-6 text-amber-400 mb-3" />
          <h3 className="font-semibold text-zinc-100">Centre d'aide</h3>
          <p className="text-zinc-400 text-sm mt-1">Guides et prise en main</p>
        </a>
      </div>
      <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-6 mt-4" data-testid="contact-report-card">
        <AlertTriangle className="w-6 h-6 text-amber-400 mb-3" />
        <h3 className="font-semibold text-zinc-100">Signaler un problème</h3>
        <p className="text-zinc-400 text-sm mt-1">Un bug, un contenu inapproprié ou un litige ? Écrivez-nous à <a href="mailto:support@cehnura.com?subject=Signalement" className="text-amber-400 hover:underline">support@cehnura.com</a> en décrivant précisément le problème. Notre équipe revient vers vous rapidement.</p>
      </div>
    </PublicPage>
  );
}

export default function Support({ kind }) {
  if (kind === "help") return <Help />;
  if (kind === "contact") return <Contact />;
  return <Faq />;
}
